import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import About from "../pages/About";
import BetaSignup from "../pages/Auth/signup";
import SignupFull from "../pages/Auth/signup/SignupFull"; 
import ForgetPassword from "../pages/Auth/forgetPassword";
import Blog from "../pages/Blog";
import Contact from "../pages/Contact";
import DND from "../pages/DND";

import AdminMain from "../layout/Admin/AdminMain";
import ManageBlog from "../adminPages/Blog/ManageBlog";
import RecoverPassword from "../pages/Auth/recoverPassword";
import { UserDashboard } from "../pages/Dashboard";

const Dashboard = React.lazy(() => import("../adminPages/Dashboard"));
const AdminBlog = React.lazy(() => import("../adminPages/Blog"));
const AdminUser = React.lazy(() => import("../adminPages/User"));
const Login = React.lazy(() => import("../pages/Auth/login"));
const Pricing = React.lazy(() => import("../pages/Pricing"));
const Main = React.lazy(() => import("../layout/Main"));
const Home = React.lazy(() => import("../pages/Home"));
const Tnc = React.lazy(() => import("../pages/Tnc"));
const Privacy = React.lazy(() => import("../pages/privacy"));
const Learn = React.lazy(() => import("../pages/Learn"));

const Router = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Main />,
      children: [
        {
          path: "/",
          exect: true,
          element: (
            <React.Suspense>
              <Home />
            </React.Suspense>
          ),
        },
        {
          path: "/about",
          exect: true,
          element: (
            <React.Suspense>
              <About />
            </React.Suspense>
          ),
        },
        {
          path: "/terms",
          exect: true,
          element: (
            <React.Suspense>
              <Tnc />
            </React.Suspense>
          ),
        },
        {
          path: "/pricing",
          exect: true,
          element: (
            <React.Suspense>
              <Pricing />
            </React.Suspense>
          ),
        },
        {
          path: "/privacy",
          exect: true,
          element: (
            <React.Suspense>
              <Privacy />
            </React.Suspense>
          ),
        },
        {
          path: "/learn",
          exect: true,
          element: (
            <React.Suspense>
              <Learn />
            </React.Suspense>
          ),
        },
        {
          path: "/blog",
          exect: true,
          element: (
            <React.Suspense>
              <Blog />
            </React.Suspense>
          ),
        },
        {
          path: "/contact-us",
          exect: true,
          element: (
            <React.Suspense>
              <Contact />
            </React.Suspense>
          ),
        },
        {
          path: "/algo",
          exect: true,
          element: (
            <React.Suspense>
              <DND mode="create" />
            </React.Suspense>
          ),
        },
        {
          path: "/algo/edit/:id",
          exect: true,
          element: (
            <React.Suspense>
              <DND mode="update" />
            </React.Suspense>
          ),
        },
        {
          path: "/dashboard",
          exect: true,
          element: (
            <React.Suspense>
              <UserDashboard />
            </React.Suspense>
          ),
        },
      ],
    },
    {
      path: "auth",
      children: [
        {
          path: "login",
          exect: true,
          element: (
            <React.Suspense>
              <Login />
            </React.Suspense>
          ),
        },
        {
          path: "signup",
          exect: true,
          element: (
            <React.Suspense>
              <BetaSignup />
            </React.Suspense>
          ),
        },
        {
          path: "signup/full",
          exect: true,
          element: (
            <React.Suspense>
              <SignupFull />
            </React.Suspense>
          ),
        },
        {
          path: "forget-password",
          exect: true,
          element: (
            <React.Suspense>
              <ForgetPassword />
            </React.Suspense>
          ),
        },
        {
          path: "profile/update",
          exect: true,
          element: (
            <React.Suspense>
              <RecoverPassword />
            </React.Suspense>
          ),
        },
      ],
    },
    {
      path: "admin",
      element: <AdminMain />,
      children: [
        {
          path: "dashboard",
          exect: true,
          element: (
            <React.Suspense>
              <Dashboard />
            </React.Suspense>
          ),
        },
        {
          path: "blogs",
          exect: true,
          element: (
            <React.Suspense>
              <AdminBlog />
            </React.Suspense>
          ),
        },
        {
          path: "blogs/create",
          exect: true,
          element: (
            <React.Suspense>
              <ManageBlog mode={"Create"} />
            </React.Suspense>
          ),
        },
        {
          path: "blogs/edit/:blogId",
          exect: true,
          element: (
            <React.Suspense>
              <ManageBlog mode={"Update"} />
            </React.Suspense>
          ),
        },
        {
          path: "users",
          exect: true,
          element: (
            <React.Suspense>
              <AdminUser />
            </React.Suspense>
          ),
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default Router;
